import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-blue-block-add-on.component.scss';
var DealsBlueBlockAddOn = /** @class */ (function (_super) {
    tslib_1.__extends(DealsBlueBlockAddOn, _super);
    function DealsBlueBlockAddOn(element) {
        return _super.call(this, element) || this;
    }
    DealsBlueBlockAddOn.prototype.init = function () { };
    DealsBlueBlockAddOn.prototype.bindEvents = function () { };
    return DealsBlueBlockAddOn;
}(Base));
export { DealsBlueBlockAddOn };



//////////////////
// WEBPACK FOOTER
// ./components/deals-blue-block-add-on/deals-blue-block-add-on.component.ts
// module id = 251
// module chunks = 0